export default {"src":"/_next/static/media/googlePlay.11f7a76a.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};